import type { oz } from '@weft/utils';
import { RegisterFormInputSchema } from './register-form-input-schema';

export const NewRegisterFormSchema = RegisterFormInputSchema
  .required()
  .refine(({ password, confirmPassword }) => password === confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords do not match',
  });

export type NewRegisterForm = oz.infer<typeof NewRegisterFormSchema>;